<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">Акты сверки</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
          Колонки
        </b-tooltip>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-row>
          <b-col cols="auto">
            <b-btn size="sm" variant="success" class="ml-1" :disabled="isBusy" @click="onCreate()">
              <font-awesome-icon icon="plus" class="mr-1"/>
              <b-spinner v-if="isBusy" small/>
              Новый
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <filters-drawer
      :query.sync="filters.query"
      :is-busy="isBusy"
      @submit="onSearch"
      hide-search-button
    />

    <b-table
      id="reconciliation-acts"
      ref="reconciliation_acts"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(create_date)="row">
        {{formatTableDate(row.item.create_date)}}
      </template>

      <template #cell(period)="row">
        {{formatTableDate(row.item.start_period)}} - {{formatTableDate(row.item.end_period)}}
      </template>

      <template #cell(action)="row">
        <b-btn size="sm" variant="primary" @click="onEdit(row.item)">
          <font-awesome-icon icon="edit"/>
        </b-btn>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <DynamicTables
      storage-key="reconciliationAct_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      :serviceEndField="serviceEndField"
      fieldKey="id"
    />

  </div>
</template>

<script>
import reconciliationActs from "../../network/reconciliationActs";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";

export default {
  name: "ReconciliationActs",
  components: { PaginationFooter, FiltersDrawer, DynamicTables },
  mixins: [
    reconciliationActs,
    helpers, dateFormatter, pageSearchService
  ],
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'id',
          class: 'reconciliation-acts-id',
          sortable: true,
          visible: true,
        },
        {
          key: 'create_date',
          label: "Дата создания",
          class: 'reconciliation-acts-date',
          sortable: true,
          visible: true,
        },
        {
          key: 'period',
          label: "Период",
          class: 'reconciliation-acts-period',
          sortable: true,
          visible: true,
        },
        {
          key: 'organization_name',
          label: "Организация",
          class: 'reconciliation-acts-organization',
          sortable: true,
          visible: true,
        },
        {
          key: 'customer_name',
          label: "Заказчик",
          class: 'reconciliation-acts-customer',
          sortable: true,
          visible: true,
        },
      ],
      serviceEndField: {
        key: 'action',
        label: "Действия",
        class: 'reconciliation-acts-action'
      },
      isBusy: false,
      sortBy: 'id',
      sortDesc: true,
      filters: {
        query: '',
      },
      deleteRow: {
        id: null,
        name: ''
      },
    }
  },
  async created() {
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        ...this.visibleFields,
        this.serviceEndField
      ];
    },
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      this.isBusy = true;
      const result = await this.getReconciliationActs(data);

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
      this.isBusy = false;
    },
    onCreate() {
      this.$router.push({name: 'ReconciliationActAdd'}).catch(()=>{});
    },
    onRowClicked(item) {
      this.onEdit(item);
    },
    onEdit(item) {
      this.$router.push({name: 'ReconciliationActEdit', params: { id: item.id }}).catch(()=>{});
    },
  }
}
</script>

<style>
#reconciliation-acts td {
  vertical-align: middle;
}

.reconciliation-acts-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.reconciliation-acts-date {
  width: 120px;
  text-align: center;
}

.reconciliation-acts-period {
  width: 200px;
  text-align: center;
}

.reconciliation-acts-organization {
  min-width: 200px;
  max-width: 200px;
}

.reconciliation-acts-customer {
  min-width: 200px;
  max-width: 200px;
}

.reconciliation-acts-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ReconciliationActs/ReconciliationActs.vue